/* ==========================================================================
   STAT FORM
   ========================================================================== */

function setCookie(name: string, value: string, days: number) {
  var expires = "";
  if (days) {
    var date = new Date();
    date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
    expires = "; expires=" + date.toUTCString();
  }
  document.cookie = name + "=" + (value || "") + expires + "; path=/";
}
function getCookie(name: string) {
  var nameEQ = name + "=";
  var ca = document.cookie.split(";");
  for (var i = 0; i < ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) == " ") c = c.substring(1, c.length);
    if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
  }
  return null;
}
function eraseCookie(name: string) {
  document.cookie = name + "=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;";
}

for (const formElement of document.querySelectorAll<HTMLFormElement>(
  ".stats-section__form"
)) {
  for (const button of formElement.querySelectorAll<HTMLLabelElement>(
    ".button"
  )) {
    button.addEventListener("click", () => {
      const radioId = button.getAttribute("for");
      const radioInput = formElement.querySelector<HTMLInputElement>(
        "#" + radioId
      );
      radioInput?.click();
      const postIdInput = formElement.querySelector<HTMLInputElement>(
        ".stat-section__post-id"
      );
      const cookieLabel = postIdInput
        ? "poll_stats-" + postIdInput?.value
        : null;

      if (cookieLabel && getCookie(cookieLabel)) {
        // User already submitted in the past
        formElement.innerHTML =
          "Sorry, you can only answer this question once.";
      } else {
        // Submit the stat form
        const { action, method } = formElement,
          body = new FormData(formElement);

        const honeypotId = formElement.dataset.honeypot;
        const honeypotValue = honeypotId ? body.get(honeypotId) : null;

        fetch(action, {
          method,
          body,
        })
          .then((response) => response.json())
          .then((response) => {
            if (response.is_valid == true && !honeypotValue) {
              formElement.innerHTML = response.confirmation_message;
              if (cookieLabel) {
                setCookie(cookieLabel, radioInput?.value ?? "undefined", 60);
              }
            } else {
              formElement.innerHTML = "Sorry, an error occured.";
            }
          })
          .catch((error) => {
            formElement.innerHTML = "An error occured.";
          });
      }
    });
  }
}
